import { styled } from "@mui/material/styles";
import { TextInput } from "react-admin";
import CustomFilterText from "../unit/CustomFilterText";
import FilterDateLastYear from "../unit/FilterDateLastYear";
import FilterProduct from "../unit/FilterProduct";

const CouponCodesApplicationsFilters = [
  <CustomFilterText label="Coupon Code" source="sCouponCode" defaultValue="" />,
  <FilterDateLastYear
    label="Sign Up"
    source="signup"
    before="and"
    variant="outlined"
  />,
  <FilterDateLastYear
    label="Application Submitted"
    source="application_submitted"
    before="and"
    variant="outlined"
  />,
  <FilterProduct label="Product" source="product" before="and" />,
];

export default CouponCodesApplicationsFilters;
